import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/coloring-page-full.tsx");
